import { HoverCard, HoverCardContent, HoverCardTrigger } from '@/components/popover/HoverCard';
import FilterMarginInfoCard from '@/pages/product/product/marginInfoCards/FilterMarginInfoCard';
import GlobalMarginInfoCard from '@/pages/product/product/marginInfoCards/GlobalMarginInfoCard';
import OveriddenMarginInfoCard from '@/pages/product/product/marginInfoCards/OveriddenMarginInfoCard';
import { MarginType, PriceBreakdownMargin } from '@/services/api/contracts/catalog/types';
import { FunctionComponent } from 'react';

// Do not move these out to a different file. For some reason the hover trigger does not work if these icons are in a different file.
const globalMarginIcon = (
  <svg
    className="cursor-pointer"
    width="37"
    height="24"
    viewBox="0 0 37 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32.25 12C32.25 16.0041 29.0041 19.25 25 19.25C20.9959 19.25 17.75 16.0041 17.75 12C17.75 7.99594 20.9959 4.75 25 4.75C29.0041 4.75 32.25 7.99594 32.25 12Z"
      fill="#F3FCFE"
      stroke="#0C3F47"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.25 5.5V9.25C22.25 10.9069 20.9068 12.25 19.25 12.25H18"
      stroke="#0C3F47"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23 18.5C23 18.5 23.75 17 23.75 15C23.75 12.8501 26.1535 14.0281 26.8267 10.7433C27.0484 9.6612 27.8954 8.75 29 8.75H31"
      stroke="#0C3F47"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M22 12L17.5 7V17L22 12Z" fill="#F3FCFE" />
    <path
      d="M13.25 6.99989L12.706 6.45689C12.2537 6.00489 11.6404 5.75098 11.001 5.75098C10.3615 5.75098 9.74827 6.00489 9.29598 6.45689L5.45698 10.2939C5.23287 10.5179 5.05508 10.7838 4.93379 11.0766C4.81249 11.3693 4.75006 11.683 4.75006 11.9999C4.75006 12.3168 4.81249 12.6305 4.93379 12.9232C5.05508 13.2159 5.23287 13.4819 5.45698 13.7059L9.29498 17.5439C10.237 18.4849 11.765 18.4849 12.706 17.5439L13.25 16.9999M19.25 11.9999H11.75H19.25ZM19.25 11.9999L16.75 9.74989L19.25 11.9999ZM19.25 11.9999L16.75 14.2499L19.25 11.9999Z"
      fill="#F3FCFE"
    />
    <path
      d="M13.25 6.99989L12.706 6.45689C12.2537 6.00489 11.6404 5.75098 11.001 5.75098C10.3615 5.75098 9.74827 6.00489 9.29598 6.45689L5.45698 10.2939C5.23287 10.5179 5.05508 10.7838 4.93379 11.0766C4.81249 11.3693 4.75006 11.683 4.75006 11.9999C4.75006 12.3168 4.81249 12.6305 4.93379 12.9232C5.05508 13.2159 5.23287 13.4819 5.45698 13.7059L9.29498 17.5439C10.237 18.4849 11.765 18.4849 12.706 17.5439L13.25 16.9999M19.25 11.9999H11.75M19.25 11.9999L16.75 9.74989M19.25 11.9999L16.75 14.2499"
      stroke="#0C3F47"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const filterMarginIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="37" height="24" viewBox="0 0 37 24" fill="none">
    <path
      d="M32.25 4.75H17.75L22.3117 10.4522C22.5954 10.8068 22.75 11.2474 22.75 11.7016V18.25C22.75 18.8023 23.1977 19.25 23.75 19.25H26.25C26.8023 19.25 27.25 18.8023 27.25 18.25V11.7016C27.25 11.2474 27.4046 10.8068 27.6883 10.4522L32.25 4.75Z"
      fill="white"
      stroke="#686868"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M22 12L17.5 7V17L22 12Z" fill="white" />
    <path
      d="M13.25 6.99989L12.706 6.45689C12.2537 6.00489 11.6404 5.75098 11.001 5.75098C10.3616 5.75098 9.7483 6.00489 9.29601 6.45689L5.45701 10.2939C5.2329 10.5179 5.05511 10.7838 4.93382 11.0766C4.81252 11.3693 4.75009 11.683 4.75009 11.9999C4.75009 12.3168 4.81252 12.6305 4.93382 12.9232C5.05511 13.2159 5.2329 13.4819 5.45701 13.7059L9.29501 17.5439C10.237 18.4849 11.765 18.4849 12.706 17.5439L13.25 16.9999M19.25 11.9999H11.75H19.25ZM19.25 11.9999L16.75 9.74989L19.25 11.9999ZM19.25 11.9999L16.75 14.2499L19.25 11.9999Z"
      fill="white"
    />
    <path
      d="M13.25 6.99989L12.706 6.45689C12.2537 6.00489 11.6404 5.75098 11.001 5.75098C10.3616 5.75098 9.7483 6.00489 9.29601 6.45689L5.45701 10.2939C5.2329 10.5179 5.05511 10.7838 4.93382 11.0766C4.81252 11.3693 4.75009 11.683 4.75009 11.9999C4.75009 12.3168 4.81252 12.6305 4.93382 12.9232C5.05511 13.2159 5.2329 13.4819 5.45701 13.7059L9.29501 17.5439C10.237 18.4849 11.765 18.4849 12.706 17.5439L13.25 16.9999M19.25 11.9999H11.75M19.25 11.9999L16.75 9.74989M19.25 11.9999L16.75 14.2499"
      stroke="#686868"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const overridenMarginIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="32" viewBox="0 0 48 32" fill="none">
    <g filter="url(#filter0_d_788_1761)">
      <path
        d="M37.2502 19.25H26.75C25.6454 19.25 24.75 18.3546 24.75 17.25V9.63478C24.75 9.22174 24.8779 8.81884 25.1161 8.48141L27.75 4.75H36.2502L38.8842 8.48141C39.1224 8.81884 39.2502 9.22174 39.2502 9.63478V17.25C39.2502 18.3546 38.3548 19.25 37.2502 19.25Z"
        stroke="#686868"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M25 9.25H39" stroke="#686868" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M32 5V9" stroke="#686868" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M26 12L21.5 7V17L26 12Z" fill="white" />
      <path
        d="M17.25 6.99989L16.706 6.45689C16.2537 6.00489 15.6404 5.75098 15.001 5.75098C14.3616 5.75098 13.7483 6.00489 13.296 6.45689L9.457 10.2939C9.23289 10.5179 9.05511 10.7838 8.93381 11.0766C8.81252 11.3693 8.75008 11.683 8.75008 11.9999C8.75008 12.3168 8.81252 12.6305 8.93381 12.9232C9.05511 13.2159 9.23289 13.4819 9.457 13.7059L13.295 17.5439C14.237 18.4849 15.765 18.4849 16.706 17.5439L17.25 16.9999M23.25 11.9999H15.75H23.25ZM23.25 11.9999L20.75 9.74989L23.25 11.9999ZM23.25 11.9999L20.75 14.2499L23.25 11.9999Z"
        fill="white"
      />
      <path
        d="M17.25 6.99989L16.706 6.45689C16.2537 6.00489 15.6404 5.75098 15.001 5.75098C14.3616 5.75098 13.7483 6.00489 13.296 6.45689L9.457 10.2939C9.23289 10.5179 9.05511 10.7838 8.93381 11.0766C8.81252 11.3693 8.75008 11.683 8.75008 11.9999C8.75008 12.3168 8.81252 12.6305 8.93381 12.9232C9.05511 13.2159 9.23289 13.4819 9.457 13.7059L13.295 17.5439C14.237 18.4849 15.765 18.4849 16.706 17.5439L17.25 16.9999M23.25 11.9999H15.75M23.25 11.9999L20.75 9.74989M23.25 11.9999L20.75 14.2499"
        stroke="#686868"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_788_1761"
        x="0"
        y="0"
        width="48"
        height="32"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_788_1761" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_788_1761" result="shape" />
      </filter>
    </defs>
  </svg>
);

type MarginInfo = {
  icon: JSX.Element;
  card: JSX.Element;
};

interface ProductMarginHoverSectionProps {
  breakdownMargin: PriceBreakdownMargin;
}

const ProductMarginHoverSection: FunctionComponent<ProductMarginHoverSectionProps> = ({ breakdownMargin }) => {
  let marginInfo: MarginInfo | null = null;
  switch (breakdownMargin.marginType) {
    case MarginType.Global:
    case MarginType.Base:
      marginInfo = {
        icon: globalMarginIcon,
        card: <GlobalMarginInfoCard />
      };
      break;
    case MarginType.Manufacturer:
    case MarginType.Category:
    case MarginType.Composite:
      marginInfo = {
        icon: filterMarginIcon,
        card: <FilterMarginInfoCard />
      };
      break;
    case MarginType.Item:
      marginInfo = {
        icon: overridenMarginIcon,
        card: <OveriddenMarginInfoCard />
      };
      break;
  }

  if (!marginInfo) return <></>;

  return (
    <HoverCard>
      <HoverCardTrigger asChild>{marginInfo.icon}</HoverCardTrigger>
      <HoverCardContent className="flex flex-col gap-1">{marginInfo.card}</HoverCardContent>
    </HoverCard>
  );
};

export default ProductMarginHoverSection;
